import { Checkbox, Stack } from '@mantine/core'
import React from 'react'
import { useToggleRefinement } from 'react-instantsearch'
import { FilterCollapsibleItem } from './FilterCollapsibleItem'

type FilterCollapsibleToggleItemProps = {
  title: string
  defaultOpened?: boolean
  attribute: string
  label: string
  on: string
}

export const FilterCollapsibleToggle = ({
  title,
  defaultOpened = false,
  attribute,
  label,
  on,
}: FilterCollapsibleToggleItemProps) => {
  const { value, refine, canRefine } = useToggleRefinement({
    attribute,
    on,
  })

  if (!canRefine) {
    return null
  }

  return (
    <FilterCollapsibleItem title={title} defaultOpened={defaultOpened}>
      <Stack gap="xs" onClick={(e) => e.stopPropagation()}>
        <Checkbox
          label={label}
          checked={value.isRefined}
          onChange={(event) => refine({ isRefined: !event.target.checked })}
          styles={{
            label: { cursor: 'pointer' },
            input: { cursor: 'pointer' },
          }}
        />
      </Stack>
    </FilterCollapsibleItem>
  )
}
